import React, { useState, useEffect } from 'react';
import { Outlet, useParams, useNavigate, Link } from "react-router-dom";
import UserLinks from '../partial/uselinks';
import { setHelperData } from '../../../recoil/atom/setHelperData';
import { useRecoilState } from "recoil";
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import { Wrapper } from '../../../mainComponent/Wrapper';
import days from '../../../data/days.json';
import Toaster from '../../Toaster';
import "react-toastify/dist/ReactToastify.css";
import { ExpandMore } from '@mui/icons-material';
import { MainNav } from '../../../mainComponent/mainNav';
import { Modal } from 'react-bootstrap';
import TouristAppointmentsApi from '../../../services/TouristAppointmentsApi';
import { MainInput } from '../../../mainComponent/mainInput';
import { MainSelect } from '../../../mainComponent/mainSelect';
import { MainButtonInput } from '../../../mainComponent/mainButtonInput';
import axios from 'axios';
import { API } from '../../../config';
import AddCircleIcon from '@mui/icons-material/AddCircle';

export default function UpdatePackage() {
    const { doctorId, packageId } = useParams();
    const [helpersData, setHelpersData] = useRecoilState(setHelperData)
    const [activity, setActivity] = useState([]);
    const [daysData, setDaysData] = useState([]); // Array of days, each with activities array
    const [selectedDays, setSelectedDays] = useState(0);
    const [packageData, setPackageData] = useState({});
    const [packages, setPackages] = useState([]);
    const [showData, setShowData] = useState(false);
    const { updatePackage, getActivities, getPackageById, GetAllPackageTypes } = TouristAppointmentsApi();
    const [documents, setDocuments] = useState([]);
    const [selectedImage, setSelectedImage] = useState(null);
    const [selectedItem, setSelectedItem] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [file, setFile] = useState(null);
    const navigate = useNavigate();

    const handleChange = (e) => {
        e.preventDefault();
        const { name, value } = e.target;
        setPackageData({ ...packageData, [name]: value });
    };

    useEffect(() => {
        getActivityTypes();
        getAllPackages();
    }, []);

    const getActivityTypes = () => {
        getPackageById(packageId)
            .then((packageResponse) => {
                // Transform package_activities to daysData structure
                const transformedDaysData = (packageResponse.package_activities || []).map(day => ({
                    activities: day.activities.map(act => ({
                        activity: act.activity,
                        details: act.details || {}
                    }))
                }));
                setPackageData(packageResponse);
                setSelectedItem(packageResponse.package_price);
                setSelectedDays(packageResponse.package_duration || 0);
                setDaysData(transformedDaysData);
                if (packageResponse.package_images) {
                    setDocuments(packageResponse.package_images);
                }
                setShowData(true);
            });
        getActivities()
            .then((res) => {
                setActivity(res);
            });
    };

    const addActivity = (dayIndex) => {
        const updatedDaysData = [...daysData];
        if (!updatedDaysData[dayIndex].activities) {
            updatedDaysData[dayIndex].activities = [];
        }
        updatedDaysData[dayIndex].activities.push({
            activity: "",
            details: {}
        });
        setDaysData(updatedDaysData);
    };

    const handleActivityChange = (e, dayIndex, activityIndex) => {
        const value = e.target.value;
        const newDaysData = [...daysData];
        newDaysData[dayIndex].activities[activityIndex].activity = value;

        // Fetch and update activity details as object with empty strings
        const selectedActivity = activity.find((item) => item.activity_name === value);
        if (selectedActivity) {
            const detailsObj = {};
            selectedActivity.activity_details.forEach(key => {
                detailsObj[key] = ""; // Initialize with empty string for each key
            });
            newDaysData[dayIndex].activities[activityIndex].details = detailsObj;
        }

        setDaysData(newDaysData);
    };

    const handleDetailChange = (e, dayIndex, activityIndex, detailKey) => {
        const value = e.target.value;
        const newDaysData = [...daysData];
        newDaysData[dayIndex].activities[activityIndex].details[detailKey] = value;
        setDaysData(newDaysData);
    };

    const handleDaysChange = (e) => {
        const value = parseInt(e.target.value, 10);
        setSelectedDays(value);

        const updatedDaysData = Array.from({ length: value }, (_, index) => ({
            activities: daysData[index]?.activities || []
        }));
        setDaysData(updatedDaysData);
        setShowData(true);
    };

    const openModal = (url) => {
        setSelectedImage(url);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedImage(null);
    };

    const handleFileChange = (event) => {
        setFile(event.target.files);
    };

    const getAllPackages = () => {
        GetAllPackageTypes()
            .then((res) => {
                setPackages(res);
            });
    };

    const handleDelete = async (url) => {
        try {
            await axios.delete(`${API}/packageimg/delete-file`, { data: { imageUrl: url } });
            getActivityTypes();
            alert("File remove successfully");
        } catch (error) {
            console.error("Error deleting file", error);
        }
    };

    const handleSelectData = (e) => {
        e.preventDefault();
        const value = e.target.value;
        setSelectedItem(value);
    };

    async function handleSubmit(e) {
        e.preventDefault();
        // Prepare activities per day in expected format
        const activitiesPerDay = daysData.map(day => ({
            activities: day.activities.map(activity => ({
                activity: activity.activity,
                details: activity.details
            }))
        }));

        const bodyData = {
            doctorId: doctorId,
            packagename: packageData.Package_name,
            excerpt: packageData.package_excerpt,
            description: packageData.package_description,
            packageprice: selectedItem,
            activitiesperday: activitiesPerDay,
            noofdays: selectedDays,
        };

        await updatePackage(packageId, bodyData)
            .then(async (res) => {
                const formData = new FormData();
                if (file) {
                    Array.from(file).forEach((singleFile) => formData.append("photo", singleFile));
                    try {
                        await axios.post(`${API}/updatepackageImg/${packageId}`, formData, {
                            headers: { "Content-Type": "multipart/form-data" }
                        });
                        alert("file uploaded successfully");
                    } catch (error) {
                        console.error("Error uploading files", error.response ? error.response.data : error.message);
                    }
                }
            });
        navigate(`/tourism/${doctorId}`);
    }

    return (
        <Wrapper>
            <MainNav>
                <ul className="clearfix ">
                    <li>
                        <Link to={`/tourism/${doctorId}`}>
                            <i className="arrow_back backArrow" title="back button"></i>
                        </Link>
                    </li>
                    <li
                        className='float-none'
                        style={{ fontSize: 'inherit' }} >
                        Update Package
                    </li>
                </ul>
            </MainNav>
            <div className="row ">
                <div className='width_16'>
                    <div className='dash row'>
                        <UserLinks
                            doctorId={doctorId}
                            helperId={helpersData._id}
                            accessModule={helpersData.access_module}
                        />
                    </div>
                </div>
                <div className='width_84 common_box'>
                    <form encType='multipart/form-data' onSubmit={handleSubmit}>
                        <div className='white-box'>
                            <div className='p-2'>
                                <div className="row">
                                    <div className="col-lg-5">
                                        <label htmlFor='name' className='helperLabel font_weight float-left'>Package Name</label>
                                        <MainInput
                                            type="text"
                                            name="Package_name"
                                            value={packageData.Package_name}
                                            onChange={handleChange}
                                            placeholder="Enter Package Name">
                                        </MainInput>

                                        <div>
                                            <label htmlFor='email' className='helperLabel font_weight float-left'>Package Plan</label>
                                        </div>
                                        <MainSelect
                                            value={selectedItem}
                                            onChange={handleSelectData}
                                        >
                                            <option value="">select Plan</option>
                                            {packages && packages.map((item, index) => (
                                                <option key={index}
                                                    value={item.packageName}
                                                    className="form-control">
                                                    {item.packageName}
                                                </option>
                                            ))}
                                        </MainSelect>
                                        <div>
                                            <label htmlFor='password' className='helperLabel font_weight float-left'>Package Description</label>
                                        </div>
                                        <div>
                                            <textarea
                                                type="text"
                                                name="package_excerpt"
                                                value={packageData.package_excerpt}
                                                onChange={handleChange}
                                                className="form-control"
                                                placeholder="short description"
                                            />
                                        </div>
                                        <div>
                                            <textarea
                                                type="text"
                                                name="package_description"
                                                value={packageData.package_description}
                                                onChange={handleChange}
                                                className="form-control"
                                                placeholder="long description"
                                            />
                                        </div>
                                        <div className='mt-2 mb-2'>
                                            <label className='helperLabel font_weight float-left'>Upload Photos</label>
                                            <>
                                                <MainInput
                                                    type="file"
                                                    accept=".png, .jpg, .jpeg"
                                                    onChange={handleFileChange}
                                                    name="photo"
                                                    multiple
                                                />
                                            </>
                                        </div>
                                        <h6 align="left" className='mb-2'>Uploaded Photos:</h6>
                                        <div className='mt-2 mb-2'>
                                            {documents.map((url, index) => (
                                                <div key={index}>
                                                    <span className='removeButton' onClick={() => handleDelete(url)}> X </span>
                                                    <img
                                                        src={url}
                                                        alt={`Uploaded file ${index + 1}`}
                                                        className='uploadedimg'
                                                        onClick={() => openModal(url)}
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    {/* adding per day activities UI */}
                                    <div className="col-lg-5">
                                        <div className="helperDiv mb-3">
                                            <label htmlFor="mobile" className="helperLabel font_weight float-left">
                                                No. Of Days*
                                            </label>
                                            <MainSelect name="selectedDays" value={selectedDays} onChange={handleDaysChange}>
                                                <option value="">Select Days</option>
                                                {days && days.map((item, index) => (
                                                    <option key={index} value={item._id} className="form-control">
                                                        {item.number}
                                                    </option>
                                                ))}
                                            </MainSelect>
                                        </div>
                                        {showData ? (
                                            <>
                                                {Array.from({ length: selectedDays }).map((_, dayIndex) => (
                                                    <div className="helperDiv" key={dayIndex}>
                                                        <Accordion defaultActiveKey="0">
                                                            <AccordionSummary
                                                                expandIcon={<ExpandMore />}
                                                                aria-controls="calendar-content"
                                                                id={`calendar-header-${dayIndex}`}
                                                            >
                                                                Day {dayIndex + 1}
                                                            </AccordionSummary>
                                                            <AccordionDetails>
                                                                <div className="mb-3">
                                                                    <label htmlFor="mobile" className="helperLabel font_weight float-left">
                                                                        Add Activities
                                                                    </label>
                                                                    <Link to="#" className="float-right" onClick={() => addActivity(dayIndex)}>
                                                                        <AddCircleIcon style={{ fontSize: 25, color: '#1976d2', marginLeft: 5, marginTop: 5 }} />
                                                                    </Link>
                                                                </div>

                                                                {/* Render all activities for this day */}
                                                                {daysData[dayIndex]?.activities?.map((activityItem, activityIndex) => (
                                                                    <div key={activityIndex} className="mb-3">
                                                                        <div className="mb-3">
                                                                            <MainSelect
                                                                                value={activityItem.activity || ""}
                                                                                onChange={(e) => handleActivityChange(e, dayIndex, activityIndex)}
                                                                            >
                                                                                <option value="">Select Activity</option>
                                                                                {activity && activity.map((item, activityMapIndex) => (
                                                                                        <option
                                                                                            key={activityMapIndex}
                                                                                            value={item.activity_name}
                                                                                            className="form-control"
                                                                                        >
                                                                                            {item.activity_name}
                                                                                        </option>
                                                                                    ))}
                                                                            </MainSelect>
                                                                        </div>

                                                                        {/* Render activity details */}
                                                                        {activityItem.details && Object.keys(activityItem.details).length > 0 && (
                                                                            <div className="activity-details mt-2">
                                                                                {Object.entries(activityItem.details).map(([key, value], detailIndex) => (
                                                                                    <div key={detailIndex} className="mb-2">
                                                                                        <label className="helperLabel float-left">
                                                                                            {key.replace(/_/g, ' ')}:
                                                                                        </label>
                                                                                        <input
                                                                                            type="text"
                                                                                            className="form-control"
                                                                                            value={value}
                                                                                            onChange={(e) => handleDetailChange(e, dayIndex, activityIndex, key)}
                                                                                            placeholder={`Enter ${key.replace(/_/g, ' ')}`}
                                                                                        />
                                                                                    </div>
                                                                                ))}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                ))}
                                                            </AccordionDetails>
                                                        </Accordion>
                                                    </div>
                                                ))}
                                            </>
                                        ) : (
                                            <>
                                                {/* Validation or empty state */}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="text-center add_top_30 pb-2">
                                <MainButtonInput>Save</MainButtonInput>
                            </div>
                        </div>
                        {isModalOpen && (
                            <Modal show={isModalOpen} onHide={closeModal}>
                                <Modal.Header closeButton onClick={(e) => e.stopPropagation()}>
                                </Modal.Header>
                                <Modal.Body>
                                    <img src={selectedImage} alt="Selected Image" className="modal-image" />
                                </Modal.Body>
                            </Modal>
                        )}
                    </form>
                    <div className="row float-right toaster">
                        <Toaster />
                    </div>
                </div>
            </div>
            <Outlet />
        </Wrapper>

    )
}
